<template>

	<Loader v-if="loading" />
	<div v-else class="upload-container small">
	    <div class="double boxes">
	        <div class="box search-properties">
	            <div class="search-field">
	                <simple-svg
	                  :filepath="'/images/SVG/Search.svg'"
	                  :width="'18px'"
	                  :height="'18px'" />
	                <form>
	                    <input type="text" v-model="search" :placeholder="$t('propertyselector.search')" autofill="off" autocomplete="false" v-on:focus="onFocus">
	                </form>
	            </div>
	            <ul v-if="propertyFilter.length > 0">
	                <li v-for="(property, i) in propertyFilter" :class="{selected: property.id == selection}" v-on:click="select(property.id)">
	                    <div class="content">
	                        <p>{{property.address}}</p>
	                        <p>{{property.zip_code}} {{property.city}}</p>
	                    </div>
	                    <div v-if="property.id == selection" class="selector">
	                        <div class="checkmark">
	                            <simple-svg
	                                :filepath="'/images/SVG/Checkmark.svg'"
	                                :width="'13px'"
	                                :height="'10px'"
	                            />
	                        </div>
	                    </div>
	                </li>
	            </ul>
	            <div v-else class="no-content">{{ $t('propertyselector.list.no-results') }}</div>
	            <div class="fade"></div>
	        </div>
	        <router-link to="#" disabled class="box add-property">
	            <div class="content">
	                <div class="icon green">
	                    <simple-svg
	                        :filepath="'/images/SVG/PropertyPlus.svg'"
	                        :width="'44px'"
	                        :height="'40px'" />
	                </div>
	                <p class="text">{{$t('propertyselector.addnew')}}</p>
	            </div>
	        </router-link>
	    </div>
	</div>

</template>

<script>
    import {mapGetters} from 'vuex';
    import Vue from 'vue';
    import Loader from "./Loader";
    import createEntity from "../mixins/create-entity";
	export default {
        mixins: [createEntity],
		props: [
			'url',
			'value',
            'next',
		],
		components: {
			Loader
		},
		data: () => ({
			search: '',
			properties: [],
			loading: false,
		}),
		computed:{
			selection: {
				get() {
					return this.value;
				},
				set(value) {
					this.$emit('input', value);
				}
			},
            propertyFilter: function () {
                return this.findBy(this.properties, this.search, ['address']);
            },
            ...mapGetters([
                'getSingleProperty',
                'getToken',
            ])
        },
		methods: {
			select(id) {
				this.selection = id;
			},
            findBy: function (list, value, column) {
                if(!value){
                    return list;
                }
                else{
                    return list.filter(function (item) {
                        return item[column[0]].toLowerCase().includes(value.toLowerCase())
                    })
                }
            },
			load() {
				Vue.api.get('/property/list', {}, {
					before: () => this.loading = true,
					always: () => this.loading = false,
					callback: data => this.parse(data),
				});
			},
			parse(data) {
				this.properties = data;
			},
			onFocus: function() {
				this.scrollToTop();
        	},
        	scrollToTop: function() {
		        window.scrollTo(0, 100);
		    },
		},
		created() {
			this.load();
		},
	}
</script>
